import React from "react";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Typography,
  Grid,
  Divider,
} from "@mui/material";
import moment from "moment";
import { ExamProps } from "./Exam";
import CardHeader, { singleLineEllipsis } from "./layouts/CardHeader";
import CountChips from "./layouts/CountChips";
import InfoBox from "./layouts/InfoBox";
import CardFooter from "./layouts/CardFooter";
import { EllipsisText } from "./Goal";

const Cluster: React.FC<any> = ({
  data,
  onclick,
  tempSelected,
  setCardsSelected,
  cardsSelected,
  child,
}) => {
  const tempS = data.id === tempSelected?.data.id;
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: tempS ? 4 : "none",
        transform: tempS ? "scale(1.01)" : "none",
        border: tempS ? "2px dashed #519C66" : "2px dashed #ccc",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          boxShadow: 4,
          transform: "scale(1.01)",
          border: "2px dashed #519C66",
        },
        mb: "16px",
        pointerEvents: tempS ? "none" : "auto",
      }}
      onClick={onclick}
    >
      <CardContent>
        <CardHeader
          name={data.name}
          onClick={onclick}
          selected={child ? true : false}
          description={data.description}
          id={data.id}
          status={data.status}
          is_active={data.is_active}
        />

        {/* Tags */}
        <Box display="flex" gap={1} flexWrap="wrap" mb={2}>
          <Chip
            label={`LOD: ${data.lod_index || 0}`}
            size="small"
            sx={{
              bgcolor: "#fef3c7",
              color: "#92400e",
              ...singleLineEllipsis,
            }}
          />
        </Box>

        {/* Stats Row */}
        <Grid container spacing={2} mb={2}>
          <Grid item xs={6} sm={3}>
            <CountChips
              label="Questions"
              selected={tempS ? cardsSelected.question : false}
              value={data.total_questions || 0}
              color="#fff7ed"
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <CountChips
              label="Exposure"
              value={`${data.exposure_index || ""}%`}
              color="#faf5ff"
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <CountChips
              label="Accuracy"
              value={`${data.accuracy_index || " "}%`}
              color="#eff6ff"
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <CountChips
              label="Retention"
              value={`${data.retention_index || " "}%`}
              color="#ecfdf5"
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} sm={6} md={6}>
            <EllipsisText
              label="Example Q ID:"
              value={`Q #${data.example_question_id}`}
            />

            <EllipsisText
              label="Time Range:"
              value={`${data.min_time}-${data.max_time}s`}
            />
            <EllipsisText label="By SME:" value={data.by_sme ? "Yes" : "No"} />
            <EllipsisText
              label="Super Start:"
              value={data.for_super_start ? "Yes" : "No"}
            />
          </Grid>{" "}
          <Grid item xs={12} sm={6} md={6}>
            <EllipsisText
              label="Languages:"
              value={
                data.languages_available
                  ? data.languages_available
                      .split(",")
                      .map((lang: string) => lang.trim())
                      .join(", ")
                  : data.primary_language ?? "-"
              }
            />
            <EllipsisText
              label="Show Translation:"
              value={data.show_translation ? "Yes" : "No"}
            />

            <EllipsisText
              label="Free Access:"
              value={data.is_free ? "Yes" : "No"}
            />
          </Grid>
        </Grid>
        <CardFooter
          internal_remark={data.internal_remark}
          created_at={data.created_at}
          created_by_id={data.created_by_id}
          modified_at={data.modified_at}
          modified_by_id={data.modified_by_id}
        />
      </CardContent>{" "}
      {child}
    </Card>
  );
};

export default Cluster;
